export default __webpack_public_path__ + "static/media/remixicon.f45d28a1.woff2";